import React, { useContext, useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { LoginContext } from "../AuthContext/LoginContext";

const SignInPageAuto = () => {
    const { email, password } = useParams();
    const { login } = useContext(LoginContext);
    const [status, setStatus] = useState('loading'); // 'loading', 'failed'
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        const attemptLogin = async () => {
            // Decode params in case they are URL encoded (though useParams usually handles basic decoding,
            // explicitly decoding verifies we handle symbols correctly like @, +, etc in emails)
            const decodedEmail = decodeURIComponent(email);
            const decodedPassword = decodeURIComponent(password);

            if (decodedEmail && decodedPassword) {
                const result = await login(decodedEmail, decodedPassword);
                // Login now returns { success: boolean, message?: string }
                if (!result || !result.success) {
                    setStatus('failed');
                    setErrorMessage(result?.message || "Unknown error occurred during login.");
                }
                // If success, logic inside login() handles navigation
            } else {
                setStatus('failed');
                setErrorMessage("Invalid credentials provided in URL.");
            }
        };
        attemptLogin();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Run once on mount

    if (status === 'loading') {
        return (
            <section className="auth-container">
                <div className="frosted-glass-card">
                    <div className="card-content" style={{ textAlign: 'center', minHeight: '300px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                        <div className="flex items-center" style={{ justifyContent: 'center', marginBottom: '1.5rem' }}>
                            <img
                                src="/assets/images/logo_fw.png"
                                alt="Logo"
                                className="logo-image"
                                style={{ maxHeight: '80px' }}
                            />
                        </div>
                        <h4 className="card-title">Auto Logging In...</h4>
                        <div className="spinner" style={{ margin: '20px auto', width: '40px', height: '40px', border: '4px solid rgba(0,0,0,0.1)', borderLeftColor: '#09f', borderRadius: '50%', animation: 'spin 1s linear infinite' }}></div>
                        <p className="card-subtitle">Verifying credentials...</p>
                        <style>{`
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `}</style>
                    </div>
                </div>
            </section>
        );
    }

    if (status === 'failed') {
        return (
            <section className="auth-container">
                <div className="frosted-glass-card">
                    <div className="card-content" style={{ textAlign: 'center' }}>
                        <div className="flex items-center" style={{ justifyContent: 'center', marginBottom: '1rem' }}>
                            <img
                                src="/assets/images/logo_fw.png"
                                alt="Logo"
                                className="logo-image"
                            />
                        </div>
                        <h4 className="card-title" style={{ color: '#dc3545', marginBottom: '10px' }}>Auto Sign In Failed</h4>
                        <p className="card-subtitle" style={{ marginBottom: '5px', fontWeight: 'bold' }}>
                            Reason:
                        </p>
                        <p className="card-subtitle" style={{ marginBottom: '20px', color: '#666' }}>
                            {errorMessage}
                        </p>
                        <div style={{ marginTop: '1rem' }}>
                            <Link to="/" className="submit-button text-center" style={{ display: 'inline-block', textDecoration: 'none', maxWidth: '300px', width: '100%' }}>
                                Go to Manual Sign In
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    return null;
};

export default SignInPageAuto;
